const labelText = ({ label }) => (label ? `${label} ` : "");

export const enConfig = {
  mixed: {
    default: (prm) => `${labelText(prm)} Is invalid.`,
    required: "This field is required!",
    oneOf: (prm) => `${labelText(prm)} Must be one of: ${prm.values}`,
    notOneOf: (prm) => `${labelText(prm)} Must not be one of: ${prm.values}`,
    notType: (prm) => {
      if (prm.type === "number") return `${labelText(prm)} Must be a number.`;
      if (prm.type === "string") return `${labelText(prm)} Must be a string.`;
      if (prm.type === "date") return `${labelText(prm)} Must be a valid date.`;
      return `${labelText(prm)} Has an invalid format.`;
    },
  },
  string: {
    length: ({ length }) => `Enter ${length} character(s).`,
    min: ({ min }) => `Enter at least ${min} character(s).`,
    max: ({ max }) => `Maximum ${max} character(s).`,
    matches: (prm) => `${labelText(prm)} Must be in valid format.`,
    email: "Invalid email.",
    url: (prm) => `${labelText(prm)} Must be a valid URL.`,
    uuid: (prm) => `${labelText(prm)} Must be a valid UUID.`,
    trim: (prm) =>
      `${labelText(prm)} Must not contain leading or trailing spaces.`,
  },
  number: {
    min: (prm) => `${labelText(prm)} Must be at least ${prm.min}.`,
    max: (prm) => `${labelText(prm)} Must be at most ${prm.max}.`,
    lessThan: (prm) => `${labelText(prm)} Must be less than ${prm.less}.`,
    moreThan: (prm) => `${labelText(prm)} Must be more than ${prm.more}.`,
    positive: (prm) => `${labelText(prm)} Must be positive.`,
    negative: (prm) => `${labelText(prm)} Must be negative.`,
    integer: (prm) => `${labelText(prm)} Must be an integer.`,
    maxDecimals: ({ label, maxDecimals }) =>
      `${labelText({
        label,
      })} Must have at most ${maxDecimals} decimal places.`,
  },
  date: {
    min: (prm) => `${labelText(prm)} Must be after ${prm.min}.`,
    max: (prm) => `${labelText(prm)} Must be before ${prm.max}.`,
  },
  boolean: {
    isValue: (prm) => `${labelText(prm)} Must be selected.`,
  },
  array: {
    length: (prm) => `${prm.length} ${labelText(prm)} are required.`,
    min: (prm) => `${labelText(prm)} Must have at least ${prm.min} items.`,
    max: (prm) => `${labelText(prm)} Must have no more than ${prm.max} items.`,
  },
};
